import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UpdateVidyoParticipantDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const muteParticipant = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: UpdateVidyoParticipantDto;
}): Promise<void> => {
  await axiosClient.post<void, UpdateVidyoParticipantDto>(
    `sessions/${sessionId}/in-call/disable-audio`,
    body,
  );
};

const unmuteParticipant = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: UpdateVidyoParticipantDto;
}): Promise<void> => {
  await axiosClient.post<void, UpdateVidyoParticipantDto>(
    `sessions/${sessionId}/in-call/enable-audio`,
    body,
  );
};

function useMuteParticipantAudio(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { sessionId: string; body: UpdateVidyoParticipantDto }
  >,
) {
  return useMutation({
    mutationFn: muteParticipant,
    ...mutationOptions,
  });
}

function useUnmuteParticipantAudio(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { sessionId: string; body: UpdateVidyoParticipantDto }
  >,
) {
  return useMutation({
    mutationFn: unmuteParticipant,
    ...mutationOptions,
  });
}

export { useMuteParticipantAudio, useUnmuteParticipantAudio };
